var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilhouetteDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3252 47.3287C51.2034 47.3287 62.0752 49.4199 62.0752 57.4961C62.0752 65.5723 51.1337 67.5937 38.3252 67.5937C25.447 67.5937 14.5752 65.4994 14.5752 57.4264C14.5752 49.3502 25.5136 47.3287 38.3252 47.3287ZM38.3252 8.21875C47.048 8.21875 54.0402 15.2082 54.0402 23.9276C54.0402 32.647 47.048 39.6365 38.3252 39.6365C29.6024 39.6365 22.6102 32.647 22.6102 23.9276C22.6102 15.2082 29.6024 8.21875 38.3252 8.21875Z",
    fill: "#616679",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilhouetteDark);
export default __webpack_public_path__ + "static/media/silhouette--dark.35c095a162f10eda4840ad5491ed6c95.svg";
export { ForwardRef as ReactComponent };